import React, { useState, useRef, useEffect } from 'react';
import { useApp } from '../../contexts/AppProvider';
import { LANGUAGES } from '../../i18n/translations';
import { Globe } from 'lucide-react';

export default function LanguageSelector() {
	const { language, changeLanguage } = useApp();
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	const currentLang = LANGUAGES.find(lang => lang.code === language) || LANGUAGES[0];

	// Close dropdown when clicking outside
	useEffect(() => {
		const handleClickOutside = (event) => {
		if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
			setIsOpen(false);
		}
		};

		document.addEventListener('mousedown', handleClickOutside);
		return () => document.removeEventListener('mousedown', handleClickOutside);
	}, []);

	return (
		<div className="relative" ref={dropdownRef}>
			<button
				onClick={() => setIsOpen(!isOpen)}
				className="flex items-center gap-2 px-3 py-2 rounded-lg transition-colors hover:bg-white/20"
				style={{ color: 'var(--color-primary)' }}
			>
				<Globe className="h-4 w-4" />
				<span className="text-sm font-medium">{currentLang.flag} {currentLang.code.toUpperCase()}</span>
			</button>

			{isOpen && (
				<div 
					className="absolute right-0 mt-2 w-40 rounded-lg shadow-lg border overflow-hidden z-50"
					style={{ 
						backgroundColor: 'var(--color-bg)',
						borderColor: 'var(--color-border)'
					}}
				>
					{LANGUAGES.map((lang) => (
						<button
						key={lang.code}
						onClick={() => {
							changeLanguage(lang.code);
							setIsOpen(false);
						}}
						className={`
							w-full px-4 py-2 text-left text-sm flex items-center gap-2
							transition-colors hover:bg-gray-100
							${lang.code === language ? 'font-semibold' : ''}
						`}
						style={{
							color: lang.code === language ? 'var(--color-primary)' : 'var(--color-text)',
							backgroundColor: lang.code === language ? 'color-mix(in srgb, var(--color-primary) 5%, transparent)' : 'transparent'
						}}
						>
							<span>{lang.flag}</span>
							<span>{lang.label}</span>
						</button>
					))}
				</div>
			)}
		</div>
	);
}